import { render, staticRenderFns } from "./SkeletonBoxWithoutLoading.vue?vue&type=template&id=5419571f&"
import script from "./SkeletonBoxWithoutLoading.vue?vue&type=script&lang=js&"
export * from "./SkeletonBoxWithoutLoading.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonBoxWithoutLoading.vue?vue&type=style&index=0&id=5419571f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports